/** 读屏专用文本。别改成 display:none 或 visibility:hidden——那样读屏也读不到。 */
export const SR_ONLY = {
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  whiteSpace: "nowrap",
  width: 1,
} as const;
